import { getMaterialCalloutDisplay } from '../../helpers/partners';
import { useHomeownerTranslate } from '../useHomeownerTranslate';

import { usePartnerCobranding, usePartnerConfiguration } from './usePartner';

export const usePartnerMaterialCallout = () => {
  const t = useHomeownerTranslate();

  const cobranding = usePartnerCobranding();
  const configuration = usePartnerConfiguration();

  if (!cobranding || !configuration || !configuration.calloutType) return null;

  const { icon, i18nKey } = getMaterialCalloutDisplay(
    configuration.calloutType,
  );

  return {
    icon,
    label: t(i18nKey, { partner: cobranding.displayName }),
  };
};
